import * as Yup from 'yup';

export const loanRequestFormSchema = (maxValue: number) =>
   Yup.object().shape({
      disbursement: Yup.date()
         .required('Campo requerido')
         .min(
            new Date(),
            'La fecha de desembolso debe ser mayor a la fecha actual'
         )
         .max(
            new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            'La fecha de desembolso no puede ser mayor a un año'
         ),
      value: Yup.number()
         .required('Campo requerido')
         .min(50000, 'El monto mínimo es de $50.000')
         .max(maxValue, `El monto máximo es de ${maxValue}`)
         .typeError('Debe ser un número'),
      period: Yup.number().required('Campo requerido'),
      frequency: Yup.string().required('Campo requerido'),
      description: Yup.string().nullable(),
      bank: Yup.string().required('Campo requerido'),
      account: Yup.string().required('Campo requerido'),
      typeAccount: Yup.string().required('Campo requerido'),
   });
